module.exports = __webpack_public_path__ + "img/zhhb-3.5992c369.png";